import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useContext, useRef, useCallback, useEffect, useMemo } from 'react';
import { atomFamily, selectorFamily, useRecoilValue, useRecoilState } from 'recoil';
import { formAtom, FormContext } from '../react-forms';
import { uuid, getValue, getIsDirty } from '../utils';
import { get as _get, set as _set, noop, cloneDeep } from 'lodash';
var initialValueSelector = selectorFamily({
  key: 'initialValue',
  get: function get(_ref) {
    var name = _ref.name,
        groupId = _ref.groupId,
        formId = _ref.formId;
    return function (_ref2) {
      var recoilGet = _ref2.get;

      var _recoilGet = recoilGet(formAtom({
        groupId: groupId,
        id: formId
      })),
          initialValues = _recoilGet.initialValues;

      return getValue(_get(initialValues, name), null);
    };
  }
});
var valueSelector = selectorFamily({
  key: 'value',
  get: function get(_ref3) {
    var name = _ref3.name,
        groupId = _ref3.groupId,
        formId = _ref3.formId;
    return function (_ref4) {
      var recoilGet = _ref4.get;

      var _recoilGet2 = recoilGet(formAtom({
        groupId: groupId,
        id: formId
      })),
          values = _valuesInstanceProperty(_recoilGet2);

      return getValue(_get(values, name), null);
    };
  },
  set: function set(_ref5) {
    var name = _ref5.name,
        groupId = _ref5.groupId,
        formId = _ref5.formId;
    return function (_ref6, newValue) {
      var recoilSet = _ref6.set;
      recoilSet(formAtom({
        groupId: groupId,
        id: formId
      }), function (prevForm) {
        return _objectSpread(_objectSpread({}, prevForm), {}, {
          values: _set(cloneDeep(_valuesInstanceProperty(prevForm)), name, newValue)
        });
      });
    };
  }
});
var touchedSelector = selectorFamily({
  key: 'touched',
  get: function get(_ref7) {
    var name = _ref7.name,
        groupId = _ref7.groupId,
        formId = _ref7.formId;
    return function (_ref8) {
      var recoilGet = _ref8.get;

      var _recoilGet3 = recoilGet(formAtom({
        groupId: groupId,
        id: formId
      })),
          touched = _recoilGet3.touched;

      return getValue(_get(touched, name), false);
    };
  },
  set: function set(_ref9) {
    var name = _ref9.name,
        groupId = _ref9.groupId,
        formId = _ref9.formId;
    return function (_ref10, newTouched) {
      var recoilSet = _ref10.set;
      recoilSet(formAtom({
        groupId: groupId,
        id: formId
      }), function (prevForm) {
        return _objectSpread(_objectSpread({}, prevForm), {}, {
          touched: _set(cloneDeep(prevForm.touched), name, newTouched)
        });
      });
    };
  }
});
var isValidatingSelector = selectorFamily({
  key: 'isValidating',
  get: function get(_ref11) {
    var name = _ref11.name,
        groupId = _ref11.groupId,
        formId = _ref11.formId;
    return function (_ref12) {
      var recoilGet = _ref12.get;

      var _recoilGet4 = recoilGet(formAtom({
        groupId: groupId,
        id: formId
      })),
          isValidating = _recoilGet4.isValidating;

      return getValue(_get(isValidating, name), false);
    };
  },
  set: function set(_ref13) {
    var name = _ref13.name,
        groupId = _ref13.groupId,
        formId = _ref13.formId;
    return function (_ref14, newIsValidating) {
      var recoilSet = _ref14.set;
      recoilSet(formAtom({
        groupId: groupId,
        id: formId
      }), function (prevForm) {
        return _objectSpread(_objectSpread({}, prevForm), {}, {
          isValidating: _set(cloneDeep(prevForm.isValidating), name, newIsValidating)
        });
      });
    };
  }
});
var errorSelector = selectorFamily({
  key: 'error',
  get: function get(_ref15) {
    var name = _ref15.name,
        groupId = _ref15.groupId,
        formId = _ref15.formId;
    return function (_ref16) {
      var recoilGet = _ref16.get;

      var _recoilGet5 = recoilGet(formAtom({
        groupId: groupId,
        id: formId
      })),
          errors = _recoilGet5.errors;

      return getValue(_get(errors, name), null);
    };
  },
  set: function set(_ref17) {
    var name = _ref17.name,
        groupId = _ref17.groupId,
        formId = _ref17.formId;
    return function (_ref18, newError) {
      var recoilSet = _ref18.set;
      recoilSet(formAtom({
        groupId: groupId,
        id: formId
      }), function (prevForm) {
        return _objectSpread(_objectSpread({}, prevForm), {}, {
          errors: _set(cloneDeep(prevForm.errors), name, newError)
        });
      });
    };
  }
});
var isDirtySelector = selectorFamily({
  key: 'isDirty',
  get: function get(_ref19) {
    var name = _ref19.name,
        groupId = _ref19.groupId,
        formId = _ref19.formId;
    return function (_ref20) {
      var recoilGet = _ref20.get;

      var _recoilGet6 = recoilGet(formAtom({
        groupId: groupId,
        id: formId
      })),
          initialValues = _recoilGet6.initialValues,
          values = _valuesInstanceProperty(_recoilGet6),
          isDirty = _recoilGet6.isDirty;

      return getValue(_get(isDirty, name), getIsDirty(name, _get(initialValues, name), _get(values, name)));
    };
  },
  set: function set(_ref21) {
    var name = _ref21.name,
        groupId = _ref21.groupId,
        formId = _ref21.formId;
    return function (_ref22, newIsDirty) {
      var recoilSet = _ref22.set;
      recoilSet(formAtom({
        groupId: groupId,
        id: formId
      }), function (prevForm) {
        return _objectSpread(_objectSpread({}, prevForm), {}, {
          isDirty: _set(cloneDeep(prevForm.isDirty), name, newIsDirty)
        });
      });
    };
  }
});
var valueAtom = atomFamily({
  key: 'fieldValue',
  default: valueSelector,
  // Required because the moment object
  // for date input changes itself
  dangerouslyAllowMutability: true
});
var touchedAtom = atomFamily({
  key: 'fieldTouched',
  default: touchedSelector
});

function useField(name) {
  var _ref23 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      propId = _ref23.id,
      _ref23$onFocus = _ref23.onFocus,
      onFocus = _ref23$onFocus === void 0 ? noop : _ref23$onFocus,
      _ref23$onChange = _ref23.onChange,
      onChange = _ref23$onChange === void 0 ? noop : _ref23$onChange,
      _ref23$onBlur = _ref23.onBlur,
      onBlur = _ref23$onBlur === void 0 ? noop : _ref23$onBlur;

  var _useContext = useContext(FormContext),
      groupId = _useContext.groupId,
      formId = _useContext.id,
      touchOnChange = _useContext.touchOnChange,
      touchOnBlur = _useContext.touchOnBlur,
      validateOnChange = _useContext.validateOnChange,
      validateOnBlur = _useContext.validateOnBlur,
      setName = _useContext.setName,
      validateField = _useContext.validateField;

  var id = useRef(propId !== null && propId !== void 0 ? propId : uuid());
  var fieldKey = {
    groupId: groupId,
    id: id.current,
    name: name,
    formId: formId
  };
  var formFieldKey = {
    name: name,
    groupId: groupId,
    formId: formId
  };

  var _useRecoilState = useRecoilState(valueAtom(fieldKey)),
      _useRecoilState2 = _slicedToArray(_useRecoilState, 2),
      value = _useRecoilState2[0],
      setValue = _useRecoilState2[1];

  var _useRecoilState3 = useRecoilState(touchedAtom(fieldKey)),
      _useRecoilState4 = _slicedToArray(_useRecoilState3, 2),
      touched = _useRecoilState4[0],
      setTouched = _useRecoilState4[1];

  var formInitialValue = useRecoilValue(initialValueSelector(formFieldKey));

  var _useRecoilState5 = useRecoilState(valueSelector(formFieldKey)),
      _useRecoilState6 = _slicedToArray(_useRecoilState5, 2),
      formValue = _useRecoilState6[0],
      setFormValue = _useRecoilState6[1];

  var _useRecoilState7 = useRecoilState(touchedSelector(formFieldKey)),
      _useRecoilState8 = _slicedToArray(_useRecoilState7, 2),
      formTouched = _useRecoilState8[0],
      setFormTouched = _useRecoilState8[1];

  var _useRecoilState9 = useRecoilState(isValidatingSelector(formFieldKey)),
      _useRecoilState10 = _slicedToArray(_useRecoilState9, 2),
      formIsValidating = _useRecoilState10[0],
      setFormIsValidating = _useRecoilState10[1];

  var _useRecoilState11 = useRecoilState(errorSelector(formFieldKey)),
      _useRecoilState12 = _slicedToArray(_useRecoilState11, 2),
      formError = _useRecoilState12[0],
      setFormError = _useRecoilState12[1];

  var _useRecoilState13 = useRecoilState(isDirtySelector(formFieldKey)),
      _useRecoilState14 = _slicedToArray(_useRecoilState13, 2),
      formIsDirty = _useRecoilState14[0],
      setFormIsDirty = _useRecoilState14[1];

  var handleFocus = useCallback(function (e) {
    onFocus(e);
  }, [onFocus]);
  var handleChange = useCallback(function (e) {
    var _e$persist;

    e === null || e === void 0 ? void 0 : (_e$persist = e.persist) === null || _e$persist === void 0 ? void 0 : _e$persist.call(e);
    var type = e.target.type;
    var val = type === 'checkbox' ? e.target.checked : type === 'file' ? e.target.files : e.target.value;
    setValue(val);
    setTouched(function (prevTouched) {
      return prevTouched || !!touchOnChange;
    });

    if (validateOnChange) {
      validateField(name, val);
    }

    onChange(e);
  }, [name, touchOnChange, validateOnChange, onChange, setValue, setTouched, validateField]);
  var handleBlur = useCallback(function (e) {
    // HACK?: Get the current value from the
    // current transaction so we can run
    // onChange and onBlur synchronously and
    // still have the right value
    var currentValue = value;
    setValue(function (prevValue) {
      currentValue = prevValue;
      return prevValue;
    });
    var currentTouched = touched;
    setTouched(function (prevTouched) {
      currentTouched = prevTouched;
      return prevTouched;
    });
    setFormValue(currentValue);
    setFormTouched(currentTouched || !!touchOnBlur);
    setFormIsDirty(getIsDirty(name, formInitialValue, currentValue));

    if (validateOnBlur) {
      validateField(name, currentValue);
    }

    onBlur(e);
  }, [name, value, touched, formInitialValue, touchOnBlur, validateOnBlur, onBlur, setValue, setTouched, setFormValue, setFormTouched, setFormIsDirty, validateField]);
  useEffect(function () {
    // Send name of this field to
    // the form when it mounts
    setName(name);
    setFormValue(value);
    setFormTouched(touched);
    setFormIsValidating(formIsValidating);
    setFormError(formError);
    setFormIsDirty(formIsDirty); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Sync field value and touched state
  // with form value and touched state

  useEffect(function () {
    setValue(function (prevValue) {
      return prevValue !== formValue ? formValue : prevValue;
    });
    setTouched(function (prevTouched) {
      return prevTouched !== formTouched ? formTouched : prevTouched;
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formValue, formTouched]);
  var input = useMemo(function () {
    return {
      id: id.current,
      name: id.current,
      value: value,
      onFocus: handleFocus,
      onChange: handleChange,
      onBlur: handleBlur
    };
  }, [id, value, handleFocus, handleChange, handleBlur]);
  var meta = useMemo(function () {
    return {
      touched: touched,
      isValidating: formIsValidating,
      error: formError,
      isDirty: formIsDirty
    };
  }, [touched, formIsValidating, formError, formIsDirty]);
  var actions = useMemo(function () {
    return {
      setValue: setFormValue,
      setTouched: setFormTouched,
      setError: setFormError,
      validate: function validate(value) {
        return validateField(name, value);
      }
    };
  }, [name, setFormValue, setFormTouched, setFormError, validateField]);
  return [input, meta, actions];
}

export { useField };